import styles from "./FailedJobs.module.css";
import { useState, useCallback, useRef} from "react";
import AGTable from "../../../components/AGTable/AGTable";
import { Button, Spinner, Popover, OverlayTrigger, ButtonToolbar } from "react-bootstrap";
import PreviewIcon from '@mui/icons-material/Preview';
const FailedJobs = (props) => {
    // Data States
    const jobs = props?.jobs;
    const userEmail = props?.userEmail;
    const updateJobs = props?.updateJobs;
    const gridRef = useRef();
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);

    let flattenedData;
    // Updates selection in Table
    const onSelectionChanged = (event) => {
        setSelected(event.selectedNodes.map(node => node?.data));
    }
    const getRowId = useCallback((params) => `${params.data.sg_master_job_id}-${params.data.job_start_time}`, []);

    if (jobs) {
        flattenedData = jobs.map((obj) => {
            // Optional: Safe handling if obj.arguments is null/undefined or invalid JSON
            let args = {};
            try {
                args = obj?.arguments_raw ? JSON.parse(obj.arguments_raw) : {};
            } catch (e) {
                args = {};
            }

            const argsHover = (
                <Popover id="popover-trigger-hover-focus">
                    <Popover.Body>
                        {Object.keys(args).map((key) => (
                            <div key={key}>
                                <strong>{key}:</strong> {String(args[key])}
                            </div>
                        ))}
                    </Popover.Body>
                </Popover>
            );

            return {
                ...obj,
                rerun_job_key: obj?.rerun_job_key ? 'https://app.zyte.com/p/' + obj?.rerun_job_key: obj?.rerun_job_key,
                arguments: (
                    <ButtonToolbar>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="bottom"
                            overlay={argsHover}
                        >
                            <Button variant="secondary" size="sm"><PreviewIcon fontSize="small"/></Button>
                        </OverlayTrigger>
                    </ButtonToolbar>
                )
            };
        });
    }

    const handleUpdateJobs = async() => {
        setLoading(true);
        await updateJobs(selected?.map((job) => {
            return {
                job_key: job?.job_key,
                reviewed: !JSON.parse(job?.reviewed),
                reviewed_by: userEmail
            }
        }));
        setLoading(false);
    };

    return (
        <div className={styles.FailedJobs}>
            {!loading && <div>

                <Button variant="success" disabled={selected.length === 0} onClick={handleUpdateJobs}>Toggle Selected Review Status</Button>
                <div style={{paddingTop: '10px'}}>
                    {flattenedData && <AGTable 
                        data={flattenedData} 
                        gridRef={gridRef}
                        columnsToHide={["filerow", "arguments_raw","job_key","job_state", "scrape_time","error", "job_close_reason", "reviewed_at", "sg_master_job_id", "spider", "is_rerun_job"]}
                        showSelect
                        setSelected={setSelected}
                        onSelectionChanged={onSelectionChanged}
                        getRowId={getRowId}
                        />}
                </div>
            </div>}
            {loading && <div className={styles.spinnerContainer}>
                <Spinner/>
            </div>}
        </div>
    )
};

export default FailedJobs;